import React, { Component } from 'react';
import './thankyou.less';
import { withRouter } from 'react-router-dom';
class ThankYou extends Component {
  render() {
    return (
      <div className="thankYouWrapper">
        <div className="thankYouInnerBox">
          <div className="thankYouMainBox">
            <div className="thankYouImgBlock">
              <img src={require('../../assets/svg/ThankYou/1.svg')} alt="" />
            </div>
            <div className="thankYouPageContent">
              <h2>Thank You for Registration</h2>
              <p>
                We have sent an email to verify your email address. Please verify your email. We will review your
                account once you verify your email address.
              </p>
              <button
                onClick={() => {
                  this.props.history.push('/signin');
                }}
                className="commonButton"
              >
                Login
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ThankYou;
